import { SVGProps } from "react"

export function IconEnergy(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" {...props}>
      <defs>
        <clipPath id="a">
          <path fill="none" d="M0 0h500v500H0z" />
        </clipPath>
      </defs>
      <g clipPath="url(#a)">
        <circle cx="246.325" cy="323.171" r="171.072" fill="#c5d3d6" />
        <path
          fill="#00515f"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M338.626 162.524c10.573-7.18 25.763-6.744 42.62 2.988 31.815 18.368 57.52 62.896 57.416 99.453-.044 15.669-4.823 27.331-12.774 34.096l-28.865 17.8-80.717-140.564z"
        />
        <path
          fill="#00515f"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M359.355 178.983c31.815 18.368 57.52 62.896 57.416 99.453s-25.976 51.302-57.791 32.934-57.524-62.893-57.42-99.451 25.981-51.304 57.796-32.936"
        />
        <path
          fill="#eef4f6"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M358.084 189.425c27.643 15.96 49.978 54.649 49.888 86.413s-22.571 44.575-50.214 28.615-49.982-54.647-49.892-86.411 22.574-44.577 50.218-28.617"
        />
        <path
          fill="#fff"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="m325.923 202.156-21.877 17.899s-63.357 3.978-98.872 51.425c-11.08 1.136-38.071 19.168-38.071 25.352 0 0-25.854 17.833-28.696 24.652-6.819 3.978-30.684 19.888-30.684 24.434-21.593 12.785-20.172 24.434-18.467 34.662-33.052 17.899-25.665 36.272-20.172 42.333-20.077 22.35 4.383 33.078 11.554 29.548 12.312-6.061 24.055-13.827 24.055-13.827s3.747 14.995 45.837 5.872c38.45-8.334 51.141-11.743 86.939-26.139.379 5.682 34.473-.947 53.413-2.652 18.941-1.705 34.094.568 39.018-3.978 4.925-4.546 25.026-29.671 44.488-54.436 11.238-14.3 6.653-59.209 6.653-59.209s10.39-6.414 14.016-10.228c6.582-33.573-28.506-90.538-69.134-85.708"
        />
        <path
          fill="none"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M237.469 418.367c-3.22-11.175 3.599-24.434 23.297-36.367 19.699-11.933 50.194-13.259 54.55-3.22"
        />
        <path
          fill="none"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M296.979 372.065c5.647-8.513 13.413-35.145 15.686-36.281s10.418-2.273 17.426 0"
        />
        <path
          fill="none"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M313.04 264.095c-18.085 20.169-18.511 41.478-.375 71.689m-207.972 102.85c-.758-5.303 3.031-18.183 38.071-27.843 22.919-14.395 38.64-20.077 42.238-19.888 8.713-9.092 24.244-19.509 30.495-19.509M69.084 422.913c4.83-4.972 23.581-14.064 29.122-17.047 5.54-2.983 36.935-26.849 43.327-26.707 8.523-8.523 40.392-25.569 47.636-27.558m-13.447-23.014c-3.836.426-32.768 15.153-43.28 26.849-7.387.426-37.219 20.598-43.185 25.144"
        />
        <path
          fill="none"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M142.764 410.79c4.546 1.326 11.649 7.955 12.975 9.755m29.264-29.643c7.387 3.22 14.016 10.702 15.058 13.448m-101.855 1.516c5.067 1.515 10.37 5.209 10.749 6.345m32.578-33.052c6.251.947 12.596 5.968 14.963 8.098m-51.045-.711c-1.326-3.338-14.498-6.942-16.831-5.618m43.822-25.492c4.83 1.847 11.838 7.908 12.785 9.423m-37.503-18.941c2.652.379 8.997 2.178 10.986 4.546m19.698-28.98c4.072 1.705 8.808 3.693 10.844 6.724m55.923-56.728c-20.172 41.552 21.735 49.294 24.576 83.103m54.029 61.894c-2.178-5.446-4.641-18.093-23.961-13.263s-24.24 13.208-22.005 15.956 22.465.013 27.87-.36 18.096-2.333 18.096-2.333m97.262-118.385c.189-10.039-5.493-28.411-9.47-34.094m-195.85 42.428c2.131 1.634 8.429 14.206.758 22.161 10.796.948 14.537 20.884 12.69 23.015 10.228-2.273 22.919 9.848 26.801 19.792 10.56-1.136 25.286 2.084 31.821 7.766m31.264-4.675c2.83-24.021-37.23-45.898-44.333-74.545"
        />
        <g fill="#ffc200" stroke="#1d1d1b" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.778">
          <path d="m186.633 360.18 13.437-119.283-34.596-20.105-13.436 119.283c-.404 3.558.619 6.088 2.489 7.175l34.596 20.105c-1.87-1.087-2.893-3.617-2.489-7.175Zm69.216-259.773c-1.281-.744-3.468-.151-6.206 1.429l-53.648 30.974 34.596 20.105 53.648-30.974c2.738-1.581 4.926-2.173 6.206-1.429z" />
          <path d="M206.946 6.351c-1.592-.925-3.796-.805-6.255.614-3.059 1.766-6.106 5.459-7.626 9.503-37.991 99.336-66.71 173.963-85.861 224.244-.224.523-4.954 10.723-1.718 12.604l34.596 20.105c-3.236-1.881 1.494-12.081 1.718-12.604 19.151-50.281 47.87-124.908 85.861-224.244 1.521-4.045 4.568-7.738 7.626-9.504 2.459-1.419 4.663-1.539 6.255-.614L206.946 6.35Z" />
          <path d="M235.288 27.07c5.347-3.087 9.493-.027 8.745 6.559L230.59 152.916l53.648-30.974c6.111-3.528 9.48-2.133 6.144 8.06-49.997 129.837-79.02 205.52-87.378 227.233-1.52 4.045-4.417 7.651-7.626 9.504-5.353 3.091-9.493.027-8.745-6.559l13.436-119.283-53.492 30.883c-13.445 7.762-5.077-10.264-4.778-10.963 19.151-50.281 47.87-124.908 85.861-224.244 1.52-4.045 4.568-7.738 7.626-9.504Z" />
        </g>
      </g>
    </svg>
  )
}
